<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="min-height: 60vh;height: auto;margin-top: -35vh;"  @click.stop>
                <div class="dialog-title" v-t="'message.item_advanced_setting_edit'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <el-form>
                        <div class="description" v-t="'message.item_advanced_setting_description'"></div>
                        <!-- 設定内容 -->
                        <table width="100%">
                            <tr class="object-titlebox" style="display: table-row;">
                                <td class="object-titlebox-text" style="padding-left:20px;"
                                    v-t="'message.item_setting_value'"></td>
                                <td class="setting-switch-header" v-t="'message.title_client_enabling'"></td>
                            </tr>
                            <!-- ロングトークグループの作成を許可する -->
                            <tr class="setting-name-1">
                                <td class="object-item">
                                    <span v-t="'message.item_advanced_enable_longTalkgroup'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left"
                                            v-html="$t('message.item_hint_buddycom_enable_help_link')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')" />
                                    </el-tooltip>
                                </td>
                                <td class="setting-switch">
                                    <el-switch v-model="enableLongTalkgroup" active-color="#5171cb"
                                        @change="handleEnableLongTalkgroupChange()">
                                    </el-switch>
                                </td>
                            </tr>
                        </table>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" v-t="'message.button_cancel'"
                        @click="$emit('cancel')"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableSave" v-t="'message.button_save'"
                        @click="saveChange()"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            enableLongTalkgroup: this.enableLongTalkgroup,
            disableSave: true
        };
    },
    props: [ 'appData' , 'enableLongTalkgroup'],

    created: function () {

    },

    methods: {
        handleEnableLongTalkgroupChange() {
            this.disableSave = false;
        },
        saveChange: function () {
            this.$emit('save', this.enableLongTalkgroup);
        }
    }
}
</script>

<style scoped>
.dialog-body {
    height: calc(65vh - 180px);
    font-size: 14px;
    overflow: auto;
    padding: 20px;
}

.setting-name-1 {
    padding-left: 20px;
    padding-top: 10px;
    vertical-align: middle;
}

.description {
    padding-bottom: 20px;
}

.setting-switch {
    text-align: right;
    padding-right: 20px;
}

.setting-switch-header {
    text-align: right;
    padding-right: 20px;
    color: #848991;
    font-size: 12px;
}

.setting-input-header {
    width: 15%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    text-align: right;
    vertical-align: top;
}
</style>
